import React from "react";
import i18next from "i18next";
import EADialog from "../common/EADialog";
import ThirdpartyInfos from '../../containers/thirdparties/thirdparty-sheet/ThirdpartyInfos';
import useStyles from "../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import AdditionalData from './sheet/AdditionalData';
import EAColorIcon from '../common/EAColorIcon';
import { PrivilegeEnum, RoleBasedAccessControlContext } from '../../services/common/RolesUtils';

const ThirdpartyInformations = ({
  isOpen,
  handleClose,
  thirdparty,
  isUnmanaged = false,
  fetchThirdpartyInfos = () => { },
  thirdpartyCode,
  setIsUpdateThirdPartyDialogOpen,
  setThirdpartyCode,
  isUpdateThirdPartyDialogOpen,
  principals,
  balanceSheetData,
  onTpCodeChange
}) => {
  const { classes } = useStyles();
  const { hasAnyOfPrivileges } = React.useContext(
    RoleBasedAccessControlContext
  );

  const Title = () => {
    return (
      <div className={classes.informationsTitleWrapper}>
        {i18next.t('thirdpartySheet.Establishments') + ' '}
        <div className={classes.informationsEtablissement}>
          <EAColorIcon
            icon={'thirdparty_green'}
            svgStyle={{
              width: '100%',
              marginRight: '5px',
              position: 'relative',
              top: '2px',
              flex: 1
            }}
            width={'20px'}
            height={'20px'}
          />
          <div>
            {thirdparty.name}
          </div>
        </div>
      </div>
    );
  };
  return (
    <EADialog
      isOpen={isOpen}
      title={<Title />}
      onCancel={handleClose}
      handleClose={handleClose}
      hasActions={false}
      maxWidth={'popuplg'}
      fullWidth
      customDialogStyle={{ padding: 0 + '!important' }}
      titleStyle={{ marginBottom: '-12px !important' }}
    >
      <hr style={{ borderColor: '#E2E2EA80' }} />
      <div style={{ padding: '16px' }}>
        {hasAnyOfPrivileges(
          PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_ID_CARD
        ) && (
          <>
            <ThirdpartyInfos
              thirdparty={thirdparty}
              isUnmanaged={isUnmanaged}
              fetchThirdpartyInfos={() => fetchThirdpartyInfos()}
              thirdpartyCode={thirdpartyCode}
              setThirdpartyCode={setThirdpartyCode}
              isUpdateThirdPartyDialogOpen={isUpdateThirdPartyDialogOpen}
              setIsUpdateThirdPartyDialogOpen={setIsUpdateThirdPartyDialogOpen}
              onTpCodeChange={onTpCodeChange}
            />
            <hr style={{ borderColor: '#E2E2EA80' }} />
          </>
        )}

        {hasAnyOfPrivileges(
          PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_OFFICERS_AGENTS,
          PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_BALANCE_SHEET
        ) && (
          <AdditionalData
            principals={principals}
            balanceSheetData={balanceSheetData}
          />
        )}
      </div>
    </EADialog>
  );
};

export default ThirdpartyInformations;
